import { trackPromise } from "react-promise-tracker";
import { toast } from "react-toastify";
import useInspectionClient from "./useInspectionClient";

type ActionMethod = "post" | "put" | "delete";

export type ApiResponse = {
  id: number | string;
};

export const useSubmitForm = <T>(
  endpoint: string,
  callback: (response: ApiResponse) => void,
  action: ActionMethod = "post",
  validation?: (data: T) => boolean,
) => {
  const client = useInspectionClient();
  const request = client.api(endpoint);

  const submit = async (data: T) => {
    // let okToSubmit = true;
      let response;

    // // If validation function provided, call it.
    // if (validation) {
    //   okToSubmit = validation(data);
    // }

    // if (okToSubmit) {
    try {
      // Send request to API.
      switch (action) {
        case "post":
          response = await trackPromise(request.post(data as FormData));
          break;
        case "put":
          response = await trackPromise(request.put(data as FormData));
          break;
        case "delete":
          response = await trackPromise(request.delete(data ?? {}));
          break;
      }

      // Redirect to AddContact page if successful.
      if (response.ok) callback(response.data);
    } catch (error: any) {
      toast.error(error.message);
    }
    // }
  };

  return submit;
};

export default useSubmitForm;
